import { getApiUrl } from 'Helpers'
import axios from 'axios'

// Response type for name change request
export interface NameChangeRequestResponse {
  jobId: number
}

export const requestNameChange = async (
  userName: string,
  currentOrgName: string,
  requestedOrgName: string,
  orgId: string,
  orgUrl: string,
  copyTo?: string[],
  replyTo?: string[],
): Promise<NameChangeRequestResponse> => {
  const url = `${getApiUrl()}/v1`
  const token = localStorage.getItem('eltoro_token')
  const config = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  }

  const requestBody = {
    route_identifier: 'RequestOrgNameChange',
    org_id: orgId,
    template_variables: {
      userName: {
        single_value: userName,
      },
      currentOrgName: {
        single_value: currentOrgName,
      },
      requestedOrgName: {
        single_value: requestedOrgName,
      },
      orgUrl: {
        single_value: orgUrl,
      },
    },
    includes: {
      cc: copyTo || [],
      reply_to: replyTo,
    },
  }

  const response = await axios
    .post(
      `${url}/notifications/routes/RequestOrgNameChange/trigger`,
      requestBody,
      {
        headers: config,
      },
    )
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      if (err) {
        throw new Error(
          JSON.stringify({
            status: err?.response?.status,
            message: err?.response?.data,
          }),
        )
      }
    })

  return { jobId: response.jobId }
}
